const DEVELOPMENT = "http://localhost:4000";
const PRODUCTION = "https://invoicemasterpro-api.onrender.com";

const API_BASE_URL = PRODUCTION;

export default API_BASE_URL;
